<template>
  <div>
    <div class="content">
      <div class="content-main">
        <p class="content-title">供应商管理<un-lock/><page-desc/></p>
        <div class="content-input">
          <div class="content-input-left">
            <div class="content-input-item">
              <label>启用状态</label>
              <el-select v-model="state" placeholder="Select" class="select-item">
                <el-option v-for="item in stateArray" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
            <!--          <div class="content-input-item">-->
            <!--            <DatePickerRange title="时间：" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>-->
            <!--          </div>-->
            <div class="content-input-item">
              <label>供应商</label>
              <SearchComponents :searchTypeList="searchTypeList" :searchType="searchType"  :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" width="7em"/>
              <!--            <el-checkbox v-model="limitState" style="margin-left: 8px;">有限制</el-checkbox>-->
            </div>
          </div>
          <div class="content-input-right">
            <div class="content-input-btn">
              <ElButtons type="primary" icon="search" v-loading="searchLoading" :disable="searchLoading" @click="getPage(true)"> 查询 </ElButtons>
              <!--            <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>-->
            </div>
          </div>

        </div>
      </div>
      <div class="content-main">
        <!--        <p class="content-title" style="padding-bottom: 16px;">用户权限</p>-->
        <div class="content-button">
          <div>
            <el-button type="primary" @click="editSupplierDialog(-1)" size="default">添加</el-button>
          </div>
          <BtnGroup :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
        </div>
        <div class="content-table">
          <el-table
              ref="multipleTableRef"
              :data="pageDataList"
              style="width: 100%; "
              v-loading="listLoading"
              size="default"
              border
          >
            <!--            <el-table-column property="id" label="ID" v-if="checkColList.indexOf('ID') > -1"/>-->
            <el-table-column property="createTime" label="创建时间" v-if="checkColList.indexOf('创建时间') > -1"/>
            <el-table-column property="name" label="供应商" v-if="checkColList.indexOf('供应商') > -1"/>
            <el-table-column property="contact" label="联系人" v-if="checkColList.indexOf('联系人') > -1"/>
            <el-table-column property="phone" label="联系电话" v-if="checkColList.indexOf('联系电话') > -1"/>
            <el-table-column property="wechat" label="微信" v-if="checkColList.indexOf('微信') > -1"/>
            <el-table-column property="shipAddress" label="发货地址" v-if="checkColList.indexOf('发货地址') > -1"/>
            <el-table-column property="remark" label="备注" v-if="checkColList.indexOf('备注') > -1"/>
            <el-table-column property="" label="状态" v-if="checkColList.indexOf('状态') > -1">
              <template #default="scope">
                <p :style="{color: scope.row.state == 2?'red':''}">{{scope.row.state == 0?'待启用':scope.row.state == 1?'已启用':scope.row.state == 2?'已停用':'' }}</p>
              </template>
            </el-table-column>
            <el-table-column property="orderNum" label="排序" v-if="checkColList.indexOf('排序') > -1"/>
            <el-table-column label="操作" v-if="checkColList.indexOf('操作') > -1">
              <template #default="scope">
                <el-space wrap>
                  <el-button @click="editSupplierDialog(scope.$index,scope.row)" size="small" type="primary">编辑</el-button>
                  <el-button v-if="scope.row.state == 0 || scope.row.state == 1" @click="updateState(scope.row, 2)" size="small" type="warning" v-loading="scope.row.updateLoading">停用</el-button>
                  <el-button v-if="scope.row.state == 0 || scope.row.state == 2" @click="updateState(scope.row, 1)" size="small" type="success" v-loading="scope.row.updateLoading">开启</el-button>
                </el-space>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
          </el-pagination>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { getFormData, postFormData } from "@/api/api";
import {getAllShopList, getSupplierPageList, updateSupplierState} from "@/api/url";
import SupplierDialog from "./components/SupplierDialog";
import Dialog from "@/assets/js/dialog"
import BtnGroup from '../../components/BtnGroup'
import SearchComponents from "@/components/SearchComponents";
import unLock from "@/layout/components/unLock";

export default {
  name: "CommoditySupplier",
  components: { BtnGroup, SearchComponents, unLock },
  data() {
    return {
      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,
      updateLoading: false,

      shopIdArray: [
        {name: '不限', id: -1},
      ],
      shopIdArr:[],
      shopId: -1,

      stateArray: [
        {label: '不限', value: -1},
        // {label: '待启用', value: 0},
        {label: '已启用', value: 1},
        {label: '已停用', value: 2}
      ],
      state: -1,

      //刷新组
      colList: ['创建时间', '供应商', '联系人', '联系电话', '微信', '发货地址','备注', '状态', '排序', '操作'],
      checkColList: [],

      //搜索
      searchTypeList: [
        {label : '门店名称', value : 1},
      ],
      searchType: 1,
      searchValue: '',

    }
  },
  methods: {

    getSearchType(e) {
      this.searchType = e;
    },
    getSearchValue(e) {
      this.searchValue = e;
    },

    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['state'] = this.state;
      // param['searchType'] = this.searchType;
      param['searchValue'] = this.searchValue;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getSupplierPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    formatTime(time) {
      let timestamp = time
      let newDate = new Date(parseInt(timestamp))
      let y = newDate.getFullYear();
      let m = newDate.getMonth()+1;
      let d = newDate.getDate();
      return  y + '-' + (m<10?'0'+m:m) + '-' + (d<10?'0'+d:d)
    },

    editSupplierDialog(idx, row) {
      let _title = '';
      let supplierForm = {}
      if (idx > -1) {
        _title = '编辑供应商'
        supplierForm = Object.assign({}, row);
        // console.log(supplierForm)
      }else {
        _title = '添加供应商'
        // console.log(supplierForm)
      }
      Dialog.open({
        title: _title,
        component: SupplierDialog,
        data: {
          supplierForm: supplierForm,
          ids: idx,
          width: '500px',
        },
        confirm: (result) => {
          this.getPage()
        }
      })
    },


    // getShopList() {
    //   getFormData(getAllShopList).then(data=> {
    //     data.data.map((item) => {
    //       if(item.id != 0) {
    //         this.shopIdArr.push(item)
    //       }
    //       this.shopIdArray = this.shopIdArray.concat(this.shopIdArr)
    //     })
    //   })
    // }


    updateState(row, state) {
      this.$confirm('确认' + (state == 1?'开启':'停用') + '【' + row.name + '】供应商吗？停用后供应商下的商品也会停用').then(() => {
        row.updateLoading = true;
        let param = {};
        param['id'] = row.id;
        param['state'] = state;
        postFormData(updateSupplierState, param).then((data)=>{
          let {code, msg} = data;
          if (code == 200) {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            })
            row.state = state
          }else {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            })
          }
          row.updateLoading = false;
        }).catch(()=> {
          row.updateLoading = false;
        })
      })

    }


  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
    // this.getShopList()
  }
}
</script>

<style scoped>
/*.el-table {*/
/*  --el-table-header-bg-color: #ffffff !important;*/
/*}*/
</style>
